import type { InjectionKey } from 'vue';

const IA_CHROME_KEY: InjectionKey<boolean> = Symbol('ia-chrome');

/**
 * Whether a coach surface is drawn inside the new information architecture's chrome: the site
 * navigation is above it, so the surface is a page you reach from that bar rather than a layer you
 * back out of, and it titles itself the way the IA's own pages do. The coach shell decides, once,
 * from the visitor's IA audience (a signed-in student); every surface under it reads the answer.
 */
export const provideIaChrome = (enabled: boolean) => provide(IA_CHROME_KEY, enabled);

export const useIaChrome = (): boolean => inject(IA_CHROME_KEY, false);
